// extracted by mini-css-extract-plugin
export default {"SavedViewsList":"Sidebar-module__SavedViewsList--MySAE","SidebarContainer":"Sidebar-module__SidebarContainer--dwykM","sidebarFooter":"Sidebar-module__sidebarFooter--fiUwg"};